import { createFileRoute } from '@tanstack/react-router';
import { BoxesPage } from '@/features/currency/boxes-page';

export const Route = createFileRoute('/_app/boxes')({
  component: BoxesPage,
});
